import React from 'react';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import LoadingSpinner from 'components/LoadingSpinner';
import { useGetActivityFieldsTypesQuery } from 'features/activity/activitySlice';

const MechanicalSLAFields = ({
    selectedParamTypes = [],
    onChange,
    disabled = false,
    showAlert = false,
    alertMessage = "Please note that changing the mechanical rule config will affect the existing rules",
    className,
    smallSize = false,
    primaryColor = false
}) => {
    const { data: fieldTypes, isLoading: isLoadingFieldsTypes } = useGetActivityFieldsTypesQuery();

    const isParamSelected = (item) =>
        !!selectedParamTypes?.find(
            (a) => a?.paramType === item?.paramType && a?.paramSubType === item?.paramSubType
        );

    const handleSelectField = (item, checked) => {
        let updatedParamTypes = selectedParamTypes || [];
        
        if (checked) {
            // Check if item already exists to prevent duplicates
            const alreadyExists = updatedParamTypes.some(
                (p) => p.paramType === item.paramType && p.paramSubType === item.paramSubType
            );
            
            if (!alreadyExists) {
                updatedParamTypes = [...updatedParamTypes, item];
                onChange(updatedParamTypes);
            }
        } else {
            // Remove the matching item
            updatedParamTypes = updatedParamTypes.filter(
                (p) => !(p.paramType === item.paramType && p.paramSubType === item.paramSubType)
            );
            onChange(updatedParamTypes);
        }
    };

    if (isLoadingFieldsTypes) {
        return <LoadingSpinner loading={true} />;
    }

    return (
        <Grid container spacing={2} direction="column">
            {showAlert && (
                <Grid item xs={12}>
                    <Alert severity="warning">
                        {alertMessage}
                    </Alert>
                </Grid>
            )}
            {fieldTypes?.map((item) => (
                <Grid item key={`${item?.paramType}-${item?.paramSubType}`}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isParamSelected(item)}
                                onChange={(event, value) => handleSelectField(item, value)}
                                disabled={disabled}
                                size={smallSize ? "small" : undefined}
                                color={primaryColor ? "primary" : undefined}
                            />
                        }
                        label={item?.name}
                        className={className}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default MechanicalSLAFields;
